import { styled } from '@mui/material';

const PREFIX = 'DocumentReferenceValueViewer';

export const classes = {
  footnote: `${PREFIX}-footnote`,
};

export const StyledFootnote = styled('sup')(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '0.75em',
  fontWeight: 600,
  marginLeft: theme.spacing(0.5),
  cursor: 'pointer',
  userSelect: 'none',
  '&:hover': {
    color: theme.palette.primary.dark,
    textDecoration: 'underline',
  },
}));

